import { jsxs, jsx } from 'react/jsx-runtime.js';
import { Button } from '@jetbrains/ring-ui/dist/button/button.js';
import CloseIcon from '@jetbrains/icons/close.js';
import cn from 'classnames';
import { H1 as PageTitle } from '../../Typography/Typography.js';
import styles from './Header.module.css.js';

var Header = function Header(props) {
  var className = props.className,
    titleTextClassName = props.titleTextClassName,
    _props$closeButtonDis = props.closeButtonDisabled,
    closeButtonDisabled = _props$closeButtonDis === void 0 ? false : _props$closeButtonDis,
    onClick = props.onClick,
    dataQdTest = props['data-qd-test'];
  return jsxs("header", {
    className: cn(styles.title, className),
    children: [jsx(PageTitle, {
      className: cn(styles.titleText, titleTextClassName),
      "data-qd-test": dataQdTest && "".concat(dataQdTest, "__title"),
      children: props.children
    }), !!onClick && jsx(Button, {
      "data-qd-test": dataQdTest && "".concat(dataQdTest, "__close-button"),
      iconClassName: styles.closeButtonIcon,
      className: styles.closeButton,
      onClick: onClick,
      icon: CloseIcon,
      disabled: closeButtonDisabled
    })]
  });
};

export { Header };
